// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uzZ2","col":"styles_col__O_N5w"};